import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../App.css";
import "../CSS/programmes/Login.css";

import CustomTextField from "../components/CustomTextField.tsx";
import { SubmitButton, DefaultButton } from "../components/Buttons.tsx";

import { AppsContext } from "../context/AppsContext.tsx";
import { ColorModeIcon } from "../context/ColorModeContext.tsx";

import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";

export function Login() {
  const backendUrl = import.meta.env.VITE_REACT_APP_BACKEND_URL;

  const [inputUserName, setInputUserName] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const [manualError, setManualError] = useState(false);
  const [errorText, setErrorText] = useState("");

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword(() => !showPassword);

  const setAppsContext = useContext(AppsContext);
  if (!setAppsContext) {
    throw new Error("AppsContext could not be loaded");
  }
  const { setApps } = setAppsContext;

  const navigate = useNavigate();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputUserName(event.target.value);
  };

  const checkCredentials = async (u: String, p: String) => {
    let data = {
      username: u,
      password: p,
    };
    localStorage.clear();
    try {
      const res = await axios.post(`${backendUrl}/login/login/`, data);
      console.log(res.status);
      localStorage.setItem("token", res.data.access.toString());
      setApps(res.data.applications);

      console.log(localStorage.getItem("token"));

      setManualError(false); // Set manual error state on login error
      setErrorText("");

      //navigate("ProgramOverview");
      return res;
    } catch (error: any) {
      localStorage.removeItem("token");
      let e = "";
      if (error.response) {
        e = error.response.data.detail;
        console.log("Error during login: " + e);
      } else {
        e = "Möglicherweise ist der Server nicht erreichbar";
      }
      setManualError(true); // Set manual error state on login error
      setErrorText(e);
      return false;
    }
  };

  const handleInputPasswordChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setInputPassword(event.target.value);
  };

  const removeInputTexts = () => {
    setManualError(false);
    setErrorText("");
    setInputUserName("");
    setInputPassword("");
  };

  const handleLoginButtonClick = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    // Prevent the default form submission behavior
    event.preventDefault();

    // Redirect to another page if necessary
    const response = await checkCredentials(inputUserName, inputPassword); //call Backend API
    if (response && response.status === 200) {
      navigate("/ProgramOverview");
    }
  };

  const renderLogin = () => {
    return (
      <div className="login-page">
        <img src="/logo-lanatura.png" alt="Lanatura Logo" />
        <h1>Anmeldung</h1>
        <h3>mit deinen Plentymarkets-Logindaten</h3>
        <div className="input-div">
          <form>
            <div className="input-fields-div">
              <CustomTextField
                type="text"
                label="Benutzername"
                placeholder="Benutzername"
                is_required={true}
                value={inputUserName}
                onChange={handleInputChange}
                manualError={manualError}
                errorText={errorText}
                // errorText="Dieses Feld muss ausgefüllt sein"
              />
              <CustomTextField
                // type="password"
                type={showPassword ? "text" : "password"}
                label="Passwort"
                placeholder="Passwort"
                is_required={true}
                value={inputPassword}
                onChange={handleInputPasswordChange}
                manualError={manualError}
                errorText={errorText}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="buttons-div">
              <DefaultButton
                label={"Eingaben entfernen"}
                onClick={removeInputTexts}
                size="small"
                variant="outlined"
              />
              <SubmitButton
                label={"Anmelden"}
                onClick={handleLoginButtonClick}
                size="small"
                type="submit"
              />
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    // <CssBaseline />
    <div>
      {renderLogin()}
      {ColorModeIcon()}
    </div>
  );
}

// export { auth };
export default Login;
// export function ToggleColorMode;
